import React from 'react';
import Header from '../components/header';

function Home(props) {
    return (
       <>
        <Header />
        <h1>home</h1>
       </>
    );
}

export default Home;